'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { ItineraryCard } from '~/components/ItineraryCard/src/ItineraryCard';
import { TRPC_SETTINGS } from '~/constants/trpc';
import { useIsTripUpdating } from '~/hooks/useIsTripUpdating';
import { useTripId } from '~/hooks/useTripId';
import { api } from '~/libs/api';
import { trackFunnelEvent } from '~/utils/funnelTracking';
import { useTripOverviewSummary } from '../hooks/useTripOverviewSummary';
import { alternativeLegTimeOptions, hasAlternativeLegTimes } from './alternativeLegTimes';
import { ChangeTravelTimesSheet } from './ChangeTravelTimesSheet';
type ChangeTravelTimesFieldProps = {
  itemId: number;
  startDate: string;
  origin: string;
  destination: string;
  departureTimeText: string | null;
  arrivalTimeText: string | null;
  isEurostar: boolean;
};
export const ChangeTravelTimesField = t0 => {
  const $ = _c(38);
  const {
    itemId,
    startDate,
    origin,
    destination,
    departureTimeText,
    arrivalTimeText,
    isEurostar
  } = t0;
  const t = useTranslations("journey");
  const tripId = useTripId();
  const [isOpen, setIsOpen] = useState(false);
  const {
    canEditTripSelections,
    isLiveChecking
  } = useTripOverviewSummary();
  const isTripUpdating = useIsTripUpdating();
  let t1;
  if ($[0] !== tripId) {
    t1 = {
      tripId
    };
    $[0] = tripId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!tripId && canEditTripSelections;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      ...TRPC_SETTINGS.QUERY_NO_REFETCH,
      enabled: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: times
  } = api.trip.getTransportTimes.useQuery(t1, t3);
  if (!canEditTripSelections) {
    return null;
  }
  let currentTime;
  let options;
  let t4;
  if ($[4] !== arrivalTimeText || $[5] !== departureTimeText || $[6] !== itemId || $[7] !== times) {
    options = alternativeLegTimeOptions(times, itemId);
    currentTime = departureTimeText && arrivalTimeText ? {
      departureTime: departureTimeText,
      arrivalTime: arrivalTimeText
    } : null;
    t4 = hasAlternativeLegTimes(options, currentTime);
    $[4] = arrivalTimeText;
    $[5] = departureTimeText;
    $[6] = itemId;
    $[7] = times;
    $[8] = currentTime;
    $[9] = options;
    $[10] = t4;
  } else {
    currentTime = $[8];
    options = $[9];
    t4 = $[10];
  }
  const canChange = t4;
  let t5;
  if ($[11] !== canChange || $[12] !== t) {
    t5 = canChange ? undefined : t("transport_train_times_only_option");
    $[11] = canChange;
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== isEurostar || $[15] !== t) {
    t6 = isEurostar ? t("transport_change_times") : t("transport_request_time_change");
    $[14] = isEurostar;
    $[15] = t;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== canChange) {
    t7 = canChange ? () => {
      trackFunnelEvent("trip_funnel_times_change");
      setIsOpen(true);
    } : undefined;
    $[17] = canChange;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = isTripUpdating || isLiveChecking;
  let t9;
  if ($[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = <ItineraryCard.ChangeField value={t5} buttonLabel={t6} testId="change-train-times" onPress={t7} isDisabled={t8} isValueSubtext={true} />;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== canChange || $[25] !== currentTime || $[26] !== destination || $[27] !== isEurostar || $[28] !== isOpen || $[29] !== itemId || $[30] !== options || $[31] !== origin || $[32] !== startDate || $[33] !== tripId) {
    t10 = canChange && <ChangeTravelTimesSheet isOpen={isOpen} close={() => setIsOpen(false)} tripId={tripId} itemId={itemId} startDate={startDate} origin={origin} destination={destination} options={options} currentTime={currentTime} requestOnly={!isEurostar} />;
    $[24] = canChange;
    $[25] = currentTime;
    $[26] = destination;
    $[27] = isEurostar;
    $[28] = isOpen;
    $[29] = itemId;
    $[30] = options;
    $[31] = origin;
    $[32] = startDate;
    $[33] = tripId;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] !== t10 || $[36] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[35] = t10;
    $[36] = t9;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  return t11;
};